module.exports = __webpack_public_path__ + "img/20191112153203360截图20191112152026964.1c5c6ed5.jpg";